export const MENUS = [
  {
    label: 'index',
    text: 'Inicio',
    textRouter: 'index',
    icon: 'pi pi-home',
    routerLink: ['/sigp/modulos/index']
  },
  {
    label: 'configuracion',
    text: 'Configuración',
    textRouter: 'configuracion',
    icon: 'pi pi-cog',
    items: [
      { label: 'dependencias', text: 'Dependencias', textRouter: 'dependencias', routerLink: ['/sigp/modulos/configuracion/dependencias'] },
      { label: 'grupos', text: 'Grupos', textRouter: 'grupos', routerLink: ['/sigp/modulos/configuracion/grupos'] },
      { label: 'recursos', text: 'Recursos', textRouter: 'recursos', routerLink: ['/sigp/modulos/configuracion/recursos'] },
      { label: 'fuentes', text: 'Fuentes', textRouter: 'fuentes', routerLink: ['/sigp/modulos/configuracion/fuentes'] },
      { label: 'entidades', text: 'Entidades', textRouter: 'entidades', routerLink: ['/sigp/modulos/configuracion/entidades'] },
      { label: 'vigencia', text: 'Vigencia', textRouter: 'vigencia', routerLink: ['/sigp/modulos/configuracion/vigencia'] },
      { label: 'tipo documento', text: 'Tipo Documento', textRouter: 'tipo-documento', routerLink: ['/sigp/modulos/configuracion/tipo-documento'] },
      { label: 'sexo', text: 'Sexo', textRouter: 'sexo', routerLink: ['/sigp/modulos/configuracion/sexo'] },
      { label: 'codigos unspsc', text: 'Códigos UNSPSC', textRouter: 'codigos-unspsc', routerLink: ['/sigp/modulos/configuracion/codigos-unspsc'] },
      { label: 'tipo contrato prestacion', text: 'Tipo Contrato Prestación', textRouter: 'tipo-contrato-prestacion', routerLink: ['/sigp/modulos/configuracion/tipo-contrato-prestacion'] },
      { label: 'conceptos de gastos', text: 'Conceptos de Gastos', textRouter: 'conceptos-gastos', routerLink: ['/sigp/modulos/configuracion/conceptos-gastos'] },
      { label: 'departamentos', text: 'Departamentos', textRouter: 'departamentos', routerLink: ['/sigp/modulos/configuracion/departamentos'] },
      { label: 'municipios', text: 'Municipios', textRouter: 'municipios', routerLink: ['/sigp/modulos/configuracion/municipios'] },
      { label: 'modalidad de seleccion', text: 'Modalidad de Selección', textRouter: 'modalidad-seleccion', routerLink: ['/sigp/modulos/configuracion/modalidad-seleccion'] },
      { label: 'tipo de autenticacion', text: 'Tipo de Autenticación', textRouter: 'tipo-autenticacion', routerLink: ['/sigp/modulos/configuracion/tipo-autenticacion'] },
      { label: 'situacion', text: 'Situación', textRouter: 'situacion', routerLink: ['/sigp/modulos/configuracion/situacion'] },
      { label: 'tipo de contrato', text: 'Tipo de Contrato', textRouter: 'tipo-contrato', routerLink: ['/sigp/modulos/configuracion/tipo-contrato'] },
      { label: 'tipo de tubros', text: 'Rubros', textRouter: 'tipo-rubros', routerLink: ['/sigp/modulos/configuracion/tipo-rubros'] },
      { label: 'rubros', text: 'Rubros', textRouter: 'rubros', routerLink: ['/sigp/modulos/configuracion/rubros'] },
      { label: 'clasificación adquisición', text: 'Clasificación adquisición', textRouter: 'clasificacion-adquisicion', routerLink: ['/sigp/modulos/configuracion/clasificacion-adquisicion'] }
    ]
  },
  {
    label: 'administracion',
    text: 'Administración',
    textRouter: 'administracion',
    icon: 'pi pi-users',
    items: [
      { label: 'roles', text: 'Roles', textRouter: 'roles', routerLink: ['/sigp/modulos/administracion/roles'] },
      { label: 'asignar rol', text: 'Asignar Rol', textRouter: 'asignar-rol', routerLink: ['/sigp/modulos/administracion/asignar-rol'] },
      { label: 'gestion de menu', text: 'Gestión de Menú', textRouter: 'gestion-menu', routerLink: ['/sigp/modulos/administracion/gestion-menu'] },
      { label: 'gestion de apis', text: 'Gestión de APIs', textRouter: 'gestion-apis', routerLink: ['/sigp/modulos/administracion/gestion-apis'] },
      { label: 'permisos por rol', text: 'Permisos por Rol', textRouter: 'permisos-por-rol', routerLink: ['/sigp/modulos/administracion/permisos-por-rol'] },
      { label: 'gestion de ldap', text: 'Gestión de LDAP', textRouter: 'gestion-ldap', routerLink: ['/sigp/modulos/administracion/gestion-ldap'] },
      { label: 'gestion de plantillas', text: 'Gestión de Plantillas', textRouter: 'gestion-plantillas', routerLink: ['/sigp/modulos/administracion/gestion-plantillas'] },
      { label: 'usuarios del sistema', text: 'Usuarios del Sistema', textRouter: 'usuarios-sistema', routerLink: ['/sigp/modulos/administracion/usuarios-sistema'] },
      { label: 'tipo de autenticacion', text: 'Tipo de Autenticación', textRouter: 'tipo-autenticacion', routerLink: ['/sigp/modulos/administracion/tipo-autenticacion'] }
    ],
  },
  {
    label: 'programacion',
    text: 'Programación',
    textRouter: 'programacion',
    icon: 'pi pi-dollar',
    items: [
      { label: 'proyectos', text: 'Proyectos', textRouter: 'proyectos', routerLink: ['/sigp/modulos/programacion/proyectos'] },
      { label: 'configurar proyectos', text: 'Configurar Proyectos', textRouter: 'configurar-proyectos', routerLink: ['/sigp/modulos/programacion/configurar-proyectos'] },
      { label: 'programar paa', text: 'Programar PAA', textRouter: 'programar-paa', routerLink: ['/sigp/modulos/programacion/programar-paa'] },
      { label: 'objetivos generales', text: 'Objetivos generales', textRouter: 'objetivos-generales', routerLink: ['/sigp/modulos/programacion/objetivos-generales'] },
      { label: 'objetivos especificos', text: 'Objetivos especificos', textRouter: 'objetivos-especificos', routerLink: ['/sigp/modulos/programacion/objetivos-especificos'] },
      { label: 'productos', text: 'Productos', textRouter: 'productos', routerLink: ['/sigp/modulos/programacion/productos'] },
      { label: 'actividades', text: 'Actividades', textRouter: 'actividades', routerLink: ['/sigp/modulos/programacion/actividades'] },
      { label: 'plan de accion', text: 'Plan de accion', textRouter: 'plan-de-accion', routerLink: ['/sigp/modulos/programacion/plan-de-accion'] }
    ],
  },
  {
    label: 'cdp',
    text: 'CDP',
    textRouter: 'cdp',
    icon: 'pi pi-clone',
    items: [
      { label: 'solicitar cdp', text: 'Solicitar CDP', textRouter: 'solicitar-cdp', routerLink: ['/sigp/modulos/cdp/solicitar-cdp'] },
      { label: 'mis cdp', text: 'Mis CDP', textRouter: 'mis-cdps', routerLink: ['/sigp/modulos/cdp/mis-cdps'] },
      { label: 'expedicion cdp', text: 'Expedición CDP', textRouter: 'expedicion-cdp', routerLink: ['/sigp/modulos/cdp/expedicion-cdp'] }
    ],
  },
  {
    label: 'mensajeria',
    text: 'Mensajería',
    textRouter: 'mensajeria',
    icon: 'pi pi-envelope',
    items: [
      { label: 'listado solicitudes', text: 'Listado Solicitudes', textRouter: 'listado-solicitudes', routerLink: ['/sigp/modulos/mensajeria/listado-solicitudes'] },
      { label: 'detalles solicitud', text: 'Detalles Solicitud', textRouter: 'detalles-solicitud', routerLink: ['/sigp/modulos/mensajeria/detalles-solicitud'] },
      { label: 'gestion de flujos', text: 'Gestión de Flujos', textRouter: 'gestion-flujos', routerLink: ['/sigp/modulos/mensajeria/gestion-flujos'] },
      { label: 'tipo de flujos', text: 'Tipo de Flujos', textRouter: 'tipo-flujos', routerLink: ['/sigp/modulos/mensajeria/tipo-flujos'] },
      { label: 'roles de flujos', text: 'Roles de Flujos', textRouter: 'roles-flujos', routerLink: ['/sigp/modulos/mensajeria/roles-flujos'] },
      { label: 'activacion de flujos', text: 'Activación de Flujos', textRouter: 'activacion-flujos', routerLink: ['/sigp/modulos/mensajeria/activacion-flujos'] }
    ]
  },
  {
    label: 'indicadores',
    text: 'Indicadores',
    textRouter: 'indicadores',
    icon: 'pi pi-list',
    items: [
      { label: 'catalogo de indicadores', text: 'Catálogo de Indicadores', textRouter: 'catalogo-indicadores', routerLink: ['/sigp/modulos/indicadores/catalogo-indicadores'] },
      { label: 'lista de indicadores', text: 'Lista de Indicadores', textRouter: 'lista-indicadores', routerLink: ['/sigp/modulos/indicadores/lista-indicadores'] },
      { label: 'configurar indicadores', text: 'Configurar Indicadores', textRouter: 'configurar-indicadores', routerLink: ['/sigp/modulos/indicadores/configurar-indicadores'] },
      { label: 'Tipo de Cálculo', textRouter: 'tipo-calculo-indicadores', routerLink: ['/sigp/modulos/indicadores/tipo-calculo-indicadores'] },
      { label: 'Tipo de Medición', textRouter: 'tipo-medicion-indicadores', routerLink: ['/sigp/modulos/indicadores/tipo-medicion-indicadores'] },
      { label: 'Unidad de Medida', textRouter: 'unidad-medida-indicadores', routerLink: ['/sigp/modulos/indicadores/unidad-medida-indicadores'] },
      { label: 'Frecuencia de Medición', textRouter: 'frecuencia-medicion-indicadores', routerLink: ['/sigp/modulos/indicadores/frecuencia-medicion-indicadores'] },
    ]
  },
  {
    label: 'reportes',
    text: 'Reportes',
    textRouter: 'reportes',
    icon: 'pi pi-chart-bar',
    items: [
      { label: 'exportar paa', text: 'Exportar PAA', textRouter: 'exportar-paa', routerLink: ['/sigp/modulos/reportes/exportar-paa'] }
    ]
  },
  {
    label: 'perfil',
    text: 'Perfil',
    textRouter: 'perfil',
    icon: 'pi pi-user',
    items: [
      { label: 'mi perfil', text: 'Mi perfil', textRouter: 'mi-perfil', routerLink: ['/sigp/modulos/perfil/mi-perfil'] }
    ]
  },
  {
    label: 'cerrar sesion',
    text: 'Cerrar Sesión',
    textRouter: 'cerrar-sesion',
    icon: 'pi pi-sign-out'
  }
];